import { inject, Injectable } from '@angular/core';
import { WINDOW } from './window-provider';
import { environment } from '@www-src/environments/environment';

export interface GtmTag {
  event: string; // event name, default is 'page'
  event_name?: string;
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: string;
  pageName?: string; // NavigationEnd urlAfterRedirects
  data?: Record<string, any>; // extra data to send
}
/**
 * For usage with Google Tag Manager to push dataLayer events
 *
 * @export
 * @class DataLayerService
 */
@Injectable({
  providedIn: 'root',
})
export class DataLayerService {
  private readonly window: Window = inject(WINDOW);

  private pingHome(obj: Record<string, any>): void {
    if (obj) (this.window as any)['dataLayer']?.push(obj);
  }

  public logPageView(item: GtmTag, event?: string): void {
    const hit: GtmTag = {
      ...item,
      event: !event ? 'page' : event,
    };
    if (environment.production) {
      this.pingHome(hit);
    } else {
      console.log('logPageView', hit);
    }
  }

  public logCustomEvent(item: Record<string, any>): void {
    if (environment.production) {
      this.pingHome(item);
    } else {
      console.log('logCustomEvent', item);
    }
  }

  logCustomDimensionTest(value: any): void {
    const hit = {
      event: 'custom-dimension',
      value: value,
    };
    if (environment.production) {
      this.pingHome(hit);
    } else {
      console.log('logCustomDimensionTest', hit);
    }
  }
}
